export const getPublicSubmissionDataPath = (
    submissionId: string,
) => `/rest/public-submission/${String(submissionId)}`;

export default (appDomain: string, submissionId: string) => `${window.location.protocol}//${appDomain}${getPublicSubmissionDataPath(submissionId)}`;
